import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { AlertTabKeySchema } from '../../-constants';
export const AlertDetailColumnKey = {
  TIMESTAMP: 'timestamp',
  WHO_ACCESSED: 'whoAccessed',
  IDENTITY: 'identity',
  IT_SERVICE: 'itService',
  CATEGORY: 'category',
  DETECTION_TOOL: 'detectionTool'
} as const;
export type AlertDetailColumnKey = (typeof AlertDetailColumnKey)[keyof typeof AlertDetailColumnKey];
export const AlertDetailSearchSchema = z.object({
  alertTab: AlertTabKeySchema.default('shadow-it'),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
  visitUserIdIn: z.array(z.string()).optional()
});
export type AlertDetailSearchParams = z.infer<typeof AlertDetailSearchSchema>;